import './style.css';

import 'maplibre-gl/dist/maplibre-gl.css';

import maplibregl from 'maplibre-gl';
import type {SourceSpecification} from "@maplibre/maplibre-gl-style-spec";

const top = 53.6362070;
const left = 2.9524976;
const right = 7.8527312;
const bottom = 50.6018318;
const imageCorners = [
    [ left,   top ],
    [ right,  top ],
    [ right,  bottom ],
    [ left,   bottom ],
] as [[number, number], [number, number], [number, number], [number, number]];

const layers = ["map", "visited", "detail", "text"];

// TODO switch to using raster backgrounds; make tile generator
const map = new maplibregl.Map({
    container: 'map',
    //style: 'https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json',
    style: {
        version: 8,
        name: "Timmity Maps",
        //id: "timmity",
        //owner: "Timmity",
        metadata: {},
        sprite: "https://tiles.basemaps.cartocdn.com/gl/voyager-gl-style/sprite",
        glyphs: "https://tiles.basemaps.cartocdn.com/fonts/{fontstack}/{range}.pbf",
        sources: Object.fromEntries(layers.map(layer => [layer, {
            type: "image",
            url: `data/${layer}.png`,
            coordinates: imageCorners,
        } as SourceSpecification])),
        layers: layers.map(layer => ({
            id: layer,
            type: "raster",
            source: layer
        })),
    },
    center: [5.41, 52.33],
    zoom: 7,
    maxZoom: 13
});

map.on("load", () => {

});
